import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
@Injectable({
    providedIn: 'root',
})
export class DataService {
    constructor() {}
    //user service comunication
    $userData = new BehaviorSubject({
        username: '',
        roles: '',
        password: '',
        description: '',
        merchant: '',
        isChange: false,
    });
    $createUser = new BehaviorSubject(true);

    $merchantData = new BehaviorSubject({
        slug: '',
        name: '',
        users: [{ username: '', role: '' }],
        isChange: false,
    });

    $createMerchant = new BehaviorSubject(true);
    $userCallBack = new BehaviorSubject(false);

    //data service comunication
    $changeRolesData = new BehaviorSubject(false);
    $createRoles = new BehaviorSubject(true);
    $rolesCallBack = new BehaviorSubject(false);

    //payment service comunication
    $changePaymentData = new BehaviorSubject(false);
    $changePaymentForm = new BehaviorSubject(false);
    $createPayment = new BehaviorSubject({
        id: 0,
        slug: '',
        name: '',
        isNeedToAdd: false,
    });
    $localStorage = new BehaviorSubject({
        key:'',
        value:[]
    });
    
}
